import { render, staticRenderFns } from "./renewalFail.vue?vue&type=template&id=c5d76ffc&scoped=true"
import script from "./renewalFail.vue?vue&type=script&lang=js"
export * from "./renewalFail.vue?vue&type=script&lang=js"
import style0 from "./renewalFail.vue?vue&type=style&index=0&id=c5d76ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d76ffc",
  null
  
)

export default component.exports